import React, { useMemo } from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import FlashHotelRateOptionVariant from '../FlashHotelRateOptionVariant'
import Group from 'components/utils/Group'
import Pane from 'components/Common/Pane'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Plural from 'components/utils/Formatters/Plural'

interface Props {
  offer: App.Offer;
  airports: Array<App.Airport>;
  packageViews: Array<OfferPackageOptionView>;
}

function FlashHotelPackageOptionsModalTab(props: Props) {
  const { offer, airports, packageViews } = props

  const destinationAirport = useMemo(() => airports.find(({ code }) => code === offer.flightDestinationPort), [airports, offer.flightDestinationPort])

  return (
    <Pane background="neutral-six">
      <Group direction="vertical" gap={8}>
        {packageViews.length > 1 && <Pane background="neutral-eight" padding="12 20">
          <BodyText variant="small" colour="neutral-three"><Plural singular="package option" count={packageViews.length} /> available</BodyText>
        </Pane>}
        {packageViews.map((view, index) => <Pane key={view.package.uniqueKey}>
          <FlashHotelRateOptionVariant
            offer={offer}
            optionNumber={index + 1}
            packageView={view}
            flightDestination={destinationAirport}
            showOptionLabel={packageViews.length > 1}
          />
        </Pane>)}
      </Group>
    </Pane>
  )
}

export default withOfferPageAndReduxState((state, appState) => {
  return {
    offer: state.offer,
    airports: appState.geo.airports,
  }
}, FlashHotelPackageOptionsModalTab)
